































import { editFactory } from '@/main/pages';
import { openList } from '@/main/router/routerPath';
import { mapActions } from 'vuex';


import { store } from './store/edit';
import { NAME } from './constants';
import { apiProvider } from './api';
import { DealerCode, DealerFilterCriteria, ExportCPFData, ExportCPFStatus, UserMessage } from './types/type';

export default editFactory(NAME, store).extend({
	computed: {
		sourceDealerFilter(): DealerFilterCriteria {
			return {
				Zone: this.SourceZone,
				City: this.SourceCity,
				Outlet: this.SourceOutlet,
			};
		},
		targetDealerFilter(): DealerFilterCriteria {
			return {
				Zone: this.TargetZone,
				City: this.TargetCity,
				Outlet: this.TargetOutlet,
			};
		},
		sourceDealer(): DealerCode {
			return {
				DealerKVPS: this.SourceDealer,
			};
		},
		exportCPF(): ExportCPFData {
			return {
				SourceDealerKVPS: this.SourceDealer,
				TargetDealerKVPS: this.TargetDealer,
				cpfIds: this.CPF,
				CreatedById: 0,
				CreatedByName: '',
			};
		},
	},
	methods: {
		...mapActions({
			clearPages: `pageManager/${'PAGE_MGR_CLEAR'}`,
		}),
		async getSourceDealer() {
			const loading = this.$loading({ fullscreen: true });
			const { data: result } = await apiProvider.getDealer(this.sourceDealerFilter);
			if (result.length === 0) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('SOURCE_DEALER_NOT_FOUND') });
			}
			this.dropdownList.SourceDealer = result;
			loading.close();
		},
		async getTargetDealer() {
			const loading = this.$loading({ fullscreen: true });
			const { data: result } = await apiProvider.getDealer(this.targetDealerFilter);
			if (result.length === 0) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('TARGET_DEALER_NOT_FOUND') });
			}
			this.dropdownList.TargetDealer = result;
			loading.close();
		},
		async getDealerCPFs() {
			const loading = this.$loading({ fullscreen: true });
			const { data: result } = await apiProvider.getDealerCPF(this.sourceDealer);
			if (result.length === 0) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CPF_NOT_FOUND') });
			}
			this.dropdownList.CPF = result;
			loading.close();
		},
		async openCPFList(checkFilters = true) {
			openList(NAME, { checkFilters });
		},
		async assignCPF() {
			if (await this.validate()) {
				this.startLoading();
				const { data: result } = await apiProvider.assignCPF(this.exportCPF);
				if (result.UserMessage === null) return;
				if (result.StatusCode === ExportCPFStatus.Failure || result.StatusCode === ExportCPFStatus.NoDataFound) {
					this.showErrorAlert({ message: this.LocalizePopisPoli(result.UserMessage) });
					if (result.UserMessage === UserMessage.CPF_STATUS_UPDATE_ERROR
					|| result.UserMessage === UserMessage.CPF_EMAIL_ERROR) {
						this.refreshPreviousPage = true;
						this.openLogs(true);
					}
					this.endLoading();
				} if (result.StatusCode === ExportCPFStatus.Success) {
					this.showNotification({ title: this.LocalizeTitle('DMS3_InfoTitle'), message: this.LocalizePopisPoli(result.UserMessage) });
					this.refreshPreviousPage = true;
					this.openLogs(true);
					this.endLoading();
				}
			}
		},
		async onSourceDealerChange() {
			if (this.SourceDealer === null) return;
			this.getDealerCPFs();
		},
		async saveClick() {
			this.assignCPF();
		},
		async openLogs(checkFilters = true) {
			await this.clearPages();
			openList(NAME, { checkFilters });
		},
	},
});
